import { useEffect, useState } from "react";
export default (value, delay, sideEffectCallback) => {
    const [debouncedValue, setDebouncedValue] = useState(value);
    useEffect(() => {
        if (value === debouncedValue) {
            return;
        }
        const timer = setTimeout(() => {
            setDebouncedValue(value);
            sideEffectCallback === null || sideEffectCallback === void 0 ? void 0 : sideEffectCallback();
        }, delay);
        return () => {
            clearTimeout(timer);
        };
    }, [value, debouncedValue, delay, sideEffectCallback]);
    return debouncedValue;
};
